module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAA+SURBVDiNY/yfJ/6fgQqAiRqGUNUgFgYmRkUy9Sow/Pu/H8ZhJNcF/wskFBj+/b8P4w++MBo1aNSgUYPwAgBXjAorD06KbwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr-code-2.png
// module id = ifEb
// module chunks = 1